























import { ref, defineComponent, computed } from '@vue/composition-api';
import { UserRoleLegacy } from '@getaccept/lib-shared/src/users/types/user-role-legacy';
import { EnumAppMode } from '@getaccept/lib-shared/src/enums/AppMode';
import { GroupFilter } from '@getaccept/lib-shared/src/enums/group-filter';
import { useSessionStore } from '../../session/store/session.store';
import { useDashboardActivities } from '../composables/dashboard-activities.composable';
import { useDashboardExpiringDocuments } from '../composables/dashboard-expiring-documents.composable';
import { useDashboardWidgets } from '../composables/dashboard-widget.composable';
import { useGroupFilter } from '../../composables/group-filter.composable';
import DashboardHeader from './DashboardHeader.vue';
import DashboardBusinessGrid from './DashboardBusinessGrid.vue';
import DashboardSalesGrid from './DashboardSalesGrid.vue';

export default defineComponent({
  components: {
    DashboardSalesGrid,
    DashboardBusinessGrid,
    DashboardHeader,
  },
  setup() {
    const sessionStore = useSessionStore();

    const { groupFilter } = useGroupFilter({ allowTeam: false });
    const loadingWidgets = ref(false);

    const isAdmin = computed(() => sessionStore.session.user_role === UserRoleLegacy.Admin);
    const showSalesGrid = computed(() => sessionStore.session.app_mode === EnumAppMode.Sales);
    const showBusinessGrid = computed(() => !!expiringDocuments.value);
    const hasRequiredData = computed(() => !!widgets.value && !!activities.value);

    const handleFilter = (filter: GroupFilter) => {
      groupFilter.value = filter;
    };

    const showAll = computed(() => groupFilter.value === GroupFilter.All);

    const { data: widgets } = useDashboardWidgets(showAll);

    const { data: activities } = useDashboardActivities(showAll);

    const { data: expiringDocuments } = useDashboardExpiringDocuments(showAll, {
      enabled: sessionStore.session.app_mode === EnumAppMode.Business,
    });

    return {
      groupFilter,
      expiringDocuments,
      widgets,
      loadingWidgets,
      activities,
      isAdmin,
      showSalesGrid,
      showBusinessGrid,
      hasRequiredData,
      handleFilter,
      sessionStore,
    };
  },
});
